import { useState, useEffect } from 'react';
import styles from './SizeAndWeightStyles.module.css';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputAdornment, TextField } from '@material-ui/core';

const DimensionNumberField = ({
  id,
  title,
  totalInches = 0,
  property,
  handleChange = () => console.log('handleChange not provided'),
  dispatchAction = "UPDATE_PROPERTY",
  hideFeet = false,
  hideInches = false,
  showMetersCalc = false,
  showMillimetersCalc = false,
  disabled = false,
}) => {


  const [open, setOpen] = useState(false);
  const [meters, setMeters] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const [localFeet, setLocalFeet] = useState(hideFeet ? 0 : Math.floor(totalInches / 12));
  const [localInches, setLocalInches] = useState(hideFeet ? totalInches : totalInches % 12);

  useEffect(() => {
    const feet = hideFeet ? 0 : Math.floor(totalInches / 12);
    const inches = hideFeet ? totalInches : totalInches % 12;
    setLocalFeet(feet);
    setLocalInches(inches);
  }, [hideFeet, totalInches])

  const handleLocalChange = (event, setLocalValue) => {
    const value = event.target.value;
    if (!isNaN(value)) {
      setLocalValue(value);
    }
  };

  const handleBlur = (event, dispatchAction, property, subProperty) => {
    let value = parseFloat(event.target.value, 10);
    if (isNaN(value)) value = 0;

    if (subProperty === 'feet') {
      value = value * 12 + localInches;
    } else if (subProperty === 'inches') {
      value = localFeet * 12 + value;
    }

    // Dispatch the change with the total inches
    handleChange(value, dispatchAction, { property: property });
  };

  const handleOk = () => {
    // Convert meters to total inches (1 meter = 39.37 inches)
    const conversionFactor = showMillimetersCalc ? 0.03937 : 39.37;
    const totalInches = Math.ceil(meters * conversionFactor);

    // Convert total inches to feet and inches
    const feet = Math.floor(totalInches / 12);
    const inches = hideFeet ? totalInches : totalInches % 12;
    setLocalFeet(feet);
    setLocalInches(inches);

    // Dispatch changes
    handleChange(totalInches, dispatchAction, { property: property });

    setOpen(false);
  };


  return (
    <div id={id + "-container"} className={`${styles['flexColumn']} ${styles['bordered']} ${styles['flexAlignCenter']}`}>
      <h4 id={id + "-title"} className={styles['dropdownLabel']}>{title}</h4>
      <div className={`${styles['flexRow']}`}>
        {!hideFeet &&
          <TextField
            id={id + "-feet-textfield"}
            type="text"
            label={"Feet"}
            variant="outlined"
            value={localFeet ?? ""}
            onFocus={(event) => event.target.select()}
            onChange={(e) => handleLocalChange(e, setLocalFeet)}
            onBlur={(e) => handleBlur(e, dispatchAction, property, 'feet')}
            inputProps={{ style: { textAlign: 'center', id: id + "-feet-input" } }}
            InputLabelProps={{ shrink: true }}
            InputProps={{ endAdornment: <InputAdornment position="end">ft</InputAdornment>, }}
            disabled={disabled}
          />
        }
        {!hideInches &&
          <TextField
            id={id + "-inches-textfield"}
            type="text"
            label={"Inches"}
            variant="outlined"
            value={localInches ?? ""}
            onFocus={(event) => event.target.select()}
            onChange={(e) => handleLocalChange(e, setLocalInches)}
            onBlur={(e) => handleBlur(e, dispatchAction, property, 'inches')}
            inputProps={{ style: { textAlign: 'center', id: id + "-inches-input" } }}
            InputLabelProps={{ shrink: true }}
            InputProps={{ endAdornment: <InputAdornment position="end">in</InputAdornment>, }}
            disabled={disabled}
          />
        }
        {(showMetersCalc || showMillimetersCalc) && <>
          <Button id={id + "-metric-button"} disabled={disabled} variant="outlined" color="primary" onClick={() => setOpen(true)}>
            Enter {showMillimetersCalc ? 'Millimeters' : 'Meters'}
          </Button>
          <Dialog id="dimension-number-field-dialog-title" open={open} onClose={handleClose} aria-labelledby="dimension-number-field-dialog-title">
            <DialogTitle id="dimension-number-field-dialog-title">Enter {showMillimetersCalc ? 'Millimeters' : 'Meters'}</DialogTitle>
            <DialogContent id="dimension-number-field-dialog-content">
              <DialogContentText id="dimension-number-field-dialog-content-text">
                Please enter the value in {showMillimetersCalc ? 'Millimeters' : 'Meters'}.
              </DialogContentText>
              {/* eslint-disable-next-line jsx-a11y/no-autofocus -- Focus the metric value input when this dialog opens. */}
              <TextField autoFocus
                margin="dense"
                id="metric-textfield"
                label={showMillimetersCalc ? 'Millimeters' : 'Meters'}
                type="number"
                fullWidth
                value={meters}
                onChange={(e) => setMeters(e.target.value)}
              />
            </DialogContent>
            <DialogActions id="dialog-actions">
              <Button id={id + "-cancel-button"} onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button id={id + "-ok-button"} onClick={handleOk} color="primary">
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </>}
      </div>
    </div>
  );
}

export default DimensionNumberField;
